import React, {useEffect, useRef} from "react";
import {useSelector} from "react-redux";
import {css, useTheme} from "@emotion/react";

import {backgroundColor, p} from "@pg-design/helpers-css";
import {Text} from "@pg-design/text-module";
import {ActiveIdType} from "@pg-mono/hooks";

import {IRPStore} from "../../../../app/rp_reducer";
import {hitClickOnArticleContents} from "../../../tracking/article_events";

interface IProps {
    activeItemId: ActiveIdType;
    id: string;
    text?: string | null;
    isPlacedInModal?: boolean;
    scrollToElementIntoView: (target: HTMLElement) => void;
}

export const ChapterItem = (props: IProps) => {
    const article = useSelector((state: IRPStore) => state.article.detail.article);
    const {activeItemId, id = "", text, isPlacedInModal, scrollToElementIntoView} = props;

    const elementRef = useRef<HTMLAnchorElement | null>(null);

    const active = activeItemId && activeItemId === id;
    const activeStyle = backgroundColor(useTheme().colors.primary);

    useEffect(() => {
        if (active && elementRef.current && !isPlacedInModal) {
            scrollToElementIntoView?.(elementRef.current);
        }
    }, [active]);

    const onChapterLinkClick = () => {
        if (article) {
            hitClickOnArticleContents({article_id: article.id});
        }
    };

    return (
        <Text as="li" variant="body_copy_2" css={item}>
            <a ref={elementRef} href={`#${id}`} css={active ? activeStyle : undefined} onClick={onChapterLinkClick}>
                {text}
            </a>
        </Text>
    );
};

const item = css`
    ${p(0)};
    list-style: none;
`;
